import React from "react";

import "./index.css";

export default function PoliticaPrivacidade() {
  return (
    <>
      <div className="d-flex justify-content-center m-5">
        <div className="c20">
          <h4 className="c14 c6 mb-4">POLÍTICA DE PRIVACIDADE</h4>

          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}
          />
          <font color="#858585">A&nbsp;</font>
          <font color="#858585">
            <b>LEO MADEIRAS, MÁQUINAS E FERRAGENS S/A</b>
          </font>
          <font color="#858585">. e a&nbsp;</font>
          <font color="#858585">
            <b>LEO SISTEMAS DE GESTÃO LTDA</b>
          </font>
          <font color="#858585">
            , por si, suas controladas, subsidiárias e seus colaboradores,&nbsp;
          </font>
          <font color="#858585">
            <b>(“REDE LEO”)</b>
          </font>
          <font color="#858585">
            , ciente da importância e do dever de privacidade das informações e documentos pessoais
            inseridos por seus usuários externos e internos (doravante “Titulares”) nos distintos
            bancos de dados da&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            , incluindo seus portais de internet e documentos físicos sob sua guarda, atuando no
            papel de Controlador do tratamento de referidos dados pessoais, estabelece a presente
            Política de Privacidade.
          </font>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}
          />
          <font color="#858585">Esclarecemos que o domínio do site&nbsp;</font>
          <font color="#858585">
            <i>
              <b>www.leomadeiras.com.br</b>
            </i>
          </font>
          <font color="#858585">
            &nbsp;é de responsabilidade da LEO SISTEMAS DE GESTÃO LTDA&nbsp;
          </font>
          <font color="#858585">
            <b>(“REDE LEO”)</b>
          </font>
          <font color="#858585">
            &nbsp;e segue a Política de Privacidade a seguir descrita:
            <br />
          </font>
          <br />
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}
          />
          <font color="#858585">
            <b>APLICABILIDADE</b>
          </font>
          <font color="#858585">
            <br />
            <br />
            Esta Política de Privacidade possui aplicabilidade única e exclusivamente aos clientes e
            titulares de dados pessoais das Lojas da&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            &nbsp;estabelecidas nas cidades de: São Paulo (SP), Guarulhos (SP), Osasco (SP), Diadema
            (SP), Santo André (SP), São Bernardo do Campo (SP), Santos (SP), Sorocaba (SP), São José
            do Rio Preto (SP), Mogi das Cruzes (SP), São José dos Campos (SP), Atibaia (SP), Rio de
            Janeiro (RJ), Duque de Caxias (RJ) e Nova Iguaçú (RJ). Caso o titular de dados/usuário
            do site seja cliente ou mantenha relação com qualquer outra loja que não esteja aqui
            relacionada, a&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            &nbsp;recomenda ao usuário acessar a Política de Privacidade aplicável à loja que mantém
            relacionamento, caso em que não são aplicáveis as condições aqui estabelecidas.
            <br />
          </font>
          <br />
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}
          />
          <font color="#858585">
            <b>LEGISLAÇÃO APLICÁVEL</b>
          </font>
          <font color="#858585">
            <br />
            <br />A presente Política de Privacidade se rege pela legislação brasileira vigente,
            especialmente pela Lei 13.709/18 (“Lei Geral de Proteção de Dados”) e Lei 12.965/14
            (“Marco Civil da Internet”).
            <br />
          </font>
          <br />
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}
          />
          <font color="#858585">
            <b>DEFINIÇÕES</b>
          </font>
          <font color="#858585">
            <br />
            <br />
            Para fins da presente Política de Privacidade, ficam estabelecidas as seguintes
            definições:
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Titular:</b>
          </font>
          <font color="#858585">
            &nbsp;pessoa natural (clientes, colaboradores, parceiros, fornecedores e prestadores) a
            quem se referem os dados pessoais que são objeto de tratamento;
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Dados Pessoais:</b>
          </font>
          <font color="#858585">
            &nbsp;são informações relacionadas à pessoa natural identificada ou identificável. Podem
            incluir, por exemplo, nome, endereço, e-mail, telefone, número de cartão de
            débito/crédito, endereço IP e dados de geolocalização;
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Dado pessoal sensível:</b>
          </font>
          <font color="#858585">
            &nbsp;categoria especial de dados pessoais referentes a origem racial ou étnica,
            convicção religiosa, opinião política, filiação a sindicato ou a organização de carácter
            religioso, filosófico ou político, referentes à saúde ou à vida sexual, dados genéticos
            ou biométricos relativos à pessoa natural;
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Dados Anonimizados:</b>
          </font>
          <font color="#858585">
            &nbsp;são informações que, isoladamente ou em conjunto com outros Dados Anonimizados,
            não permitem a identificação de uma pessoa, considerando a utilização de meios técnicos
            razoáveis e disponíveis na ocasião de seu tratamento. Podem incluir gênero, idade e
            geolocalização generalizada (como a cidade em que se encontra) e dados estatísticos;
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Bases de Dados:</b>
          </font>
          <font color="#858585">
            &nbsp;conjunto estruturado de dados pessoais, estabelecido em um ou em vários locais, em
            suporte eletrônico ou físico;
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Tratamento de dados pessoais:</b>
          </font>
          <font color="#858585">
            &nbsp;toda operação realizada com dados pessoais, como as que se referem: a coleta,
            produção, recepção, classificação, utilização, acesso, reprodução, transmissão,
            distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou
            controle da informação, modificação, comunicação, transferência, difusão ou extração;
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Controlador:</b>
          </font>
          <font color="#858585">
            &nbsp;pessoa natural ou jurídica, de direito público ou privado, a quem competem as
            decisões referentes ao tratamento de dados pessoais;
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Operador:</b>
          </font>
          <font color="#858585">
            &nbsp;pessoa natural ou jurídica, de direito público ou privado, que realiza o
            tratamento de dados pessoais em nome do controlador;
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Encarregado / DPO:</b>
          </font>
          <font color="#858585">
            &nbsp;pessoa indicada pelo controlador e operador para atuar como canal de comunicação
            entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção de Dados
            (ANPD);
            <br />
            <br />
          </font>
          <font color="#858585">
            <b>Usuário:</b>
          </font>
          <font color="#858585">
            &nbsp;pessoas que acessam ou interagem com atividades oferecidas nos distintos portais
            de internet de propriedade da&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            &nbsp;e de empresas de seu grupo empresarial, sob seu controle direto ou indireto.
            <br />
          </font>
          <br />
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}
          />
          <font color="#858585">
            <b>PROPÓSITO DA POLÍTICA DE PRIVACIDADE</b>
          </font>
          <font color="#858585">
            <br />
            <br />
            A&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO&nbsp;</b>
          </font>
          <font color="#858585">
            valoriza a privacidade de seus usuários e criou esta Política de Privacidade para
            demonstrar seu compromisso em proteger a sua privacidade e seus dados pessoais, nos
            termos da Lei Geral de Proteção de Dados e demais leis sobre o tema, bem como descrever
            de que forma sua privacidade é protegida pela&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            &nbsp;ao coletar, tratar e armazenar seus dados pessoais.
            <br />
            <br />
            A&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">&nbsp;segue o Código de Conduta e Ética&nbsp;</font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            &nbsp;(“Código de Conduta”) que representa a missão, a visão e os valores da&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            , feito com objetivo de orientar e retratar quais os valores prioritários desta Empresa
            desde sua concepção, sempre visando uma atuação ética de todos os seus clientes,
            fornecedores e colaboradores.).
            <br />
            <br />O objetivo desta Política de Privacidade é informar aos titulares dos Dados
            Pessoais as diretivas de coleta, tratamento, armazenamento e proteção das informações e
            documentos físicos e digitais, (doravante “Dados Pessoais”), coletados pela&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            &nbsp;ou em seu nome, ou inseridos diretamente por seus titulares (externos e internos)
            em suas plataformas digitais e físicas, esclarecendo como os seus Dados Pessoais serão
            tratados, bem como quais são os seus direitos e como eles poderão ser exercidos.
            <br />
          </font>
          <br />
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}
          />
          <font color="#858585">
            <b>TRATAMENTO DE DADOS PESSOAIS</b>
          </font>
          <font color="#858585">
            <br />
            <br />
            Os dados coletados pela&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            , inclusive dados pessoais, poderão ser objeto de tratamento e observarão a finalidade,
            adequação, necessidade, livre acesso, qualidade dos dados, transparência, segurança,
            prevenção, não discriminação, responsabilização e prestação de contas, sempre em
            observância ao princípio da boa-fé, sendo incorporados aos correspondentes registros
            físicos e eletrônicos (doravante, “Registro”) ou em Bancos de Dados sobre quais a&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            &nbsp;atuará como Controlador.
            <br />
            <br />
            A&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            &nbsp;esclarece que eventuais Dados Pessoais coletados serão tratados apenas quando
            houver propósito e objetivo regulares, sob consentimento do Titular ou sob previsão
            legal, nas hipóteses previstas na legislação vigente, inclusive quando necessário para
            atender aos interesses legítimos da&nbsp;
          </font>
          <font color="#858585">
            <b>REDE LEO</b>
          </font>
          <font color="#858585">
            , desde que não conflitantes com os direitos e liberdades fundamentais do titular que
            exijam a proteção dos dados pessoais.
            <br />
            <br />
            Dados que passam por processo de anonimização (“Dados Anonimizados”) durante seu
            tratamento, não serão considerados Dados Pessoais para fins dessa Política de
            Privacidade, uma vez que perdem a possibilidade de associação, direta ou indireta, à um
            indivíduo, nos termos da legislação vigente.
            <br />
          </font>
          <br />
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>FINALIDADE DO TRATAMENTO DE DADOS PESSOAIS</b>
            </font>
            <font color="#858585">
              <br />
              <br />O tratamento de dados pessoais pela&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;terá as seguintes finalidades:
              <br />
              <br />
               (i)  Prestação dos serviços inerentes às atividades da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;e de seu grupo empresarial aos Titulares;
              <br />
               (ii)  Atendimento de obrigações legais ou regulatórias;
              <br />
               (iii)  Execução de contratos ou de procedimentos preliminares necessários
              relacionados a contrato do qual seja parte o Titular;
              <br />
               (iv)  Atendimento de interesses legítimos da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO&nbsp;</b>
            </font>
            <font color="#858585">
              ou de terceiros contratados por esta, resguardados os direitos e liberdades
              fundamentais do titular que exijam a proteção dos Dados Pessoais;
              <br />
               (v)  Relacionamento e fornecimento de informações sobre produtos e serviços
              contratados pelos clientes da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              ;<br />
               (vi)  Elaboração de estudos e campanhas visando facilitar a oferta e prestação de
              serviços diversos daqueles primariamente contratados, avaliando o interesse do Titular
              em contratar novos serviços ou adquirir novos produtos da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO;</b>
            </font>
            <font color="#858585">
              <br />
               (vii)  Exercício regular de direitos em processo judicial, administrativo ou
              arbitral.
            </font>
          </p>
          <p style={{lineHeight: "100%"}}>
            <font color="#333333">
              <br />
            </font>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>TIPOS DE DADOS PESSOAIS QUE PODERÃO SER COLETADOS E TRATADOS PELA REDE LEO</b>
            </font>
            <font color="#858585">
              <br />
              <br />
              A&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO&nbsp;</b>
            </font>
            <font color="#858585">
              poderá obter os seguintes dados pessoais para atendimento aos seus clientes,
              fornecedores ou colaboradores:
              <br />
               (i)  Dados cadastrais e/ou de contato;
              <br />
               (ii)  Dados profissionais e/ou jurídicos;
              <br />
               (iii)  Dados de identificação gerados por órgãos oficiais;
              <br />
               (iv)  Dados financeiros / de pagamento;
              <br />
               (v)  Dados de identificação junto à&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;(Ex.: cadastros para acesso aos portais de relacionamento);
              <br />
               (vi)  Dados de preferências do Titular (Ex.: dados baseados em navegação na internet,
              em sites próprios ou relacionados).
              <br />
               (vii)  Dados relacionados à oferta de produtos e serviços comercializados pela&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              .<br />
            </font>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>FORMAS DE COLETA DOS DADOS PESSOAIS</b>
            </font>
            <font color="#858585">
              <br />
              <br />
              (i)    
            </font>
            <font color="#858585">
              <b>Fornecimento diretamente pelo Titular ou seus representantes legais:</b>
            </font>
            <font color="#858585">
              &nbsp;dados pessoais inseridos, fornecidos fisicamente ou encaminhados ao acessar um
              dos nossos canais (sites ou aplicativos) ou ao consultar, candidatar-se e/ou contratar
              produtos e/ou serviços fornecidos&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              ;<br />
              (ii)    
            </font>
            <font color="#858585">
              <b>Coletados diretamente pela REDE LEO e com o consentimento do Titular:</b>
            </font>
            <font color="#858585">
              &nbsp;dados coletados durante processos comerciais, campanhas de marketing, terceiros
              autorizados, relativos ou não a prospecção e venda de produtos e serviços pela&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              ;<br />
              (iii)    
            </font>
            <font color="#858585">
              <b>Fornecimento por terceiros contratados:</b>
            </font>
            <font color="#858585">
              &nbsp;Dados Pessoais recebidos de terceiros, atuando em parceria com a&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              , como prestadores de serviços de enriquecimento das informações coletadas diretamente
              pela&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              , desde que expressamente autorizado pelo Titular;
              <br />
              (iv)    
            </font>
            <font color="#858585">
              <b>Coletados a partir de bases públicas:</b>
            </font>
            <font color="#858585">
              &nbsp;dados de bases públicas, disponibilizadas por autoridades (como a Receita
              Federal, por exemplo), instituições de créditos ou de proteção ao crédito ou dados
              tornados explicitamente públicos pelo Titular, como por exemplo, em websites ou rede
              sociais, resguardados os direitos e liberdades fundamentais do titular que exijam a
              proteção dos Dados Pessoais;
              <br />
              (v)    
            </font>
            <font color="#858585">
              <b>Coletados automaticamente:</b>
            </font>
            <font color="#858585">
              &nbsp;coleta de informações de modo automático, associada à informação pessoalmente
              identificável, utilizando ferramentas de tecnologia, como Cookies, que será informado
              ao Titular.
              <br />
            </font>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>DIREITOS DO TITULAR DOS DADOS PESSOAIS</b>
            </font>
            <font color="#858585">
              <br />
              <br />
              Aos Titulares são garantidos os direitos fundamentais de liberdade, de intimidade e de
              privacidade, assegurada a titularidade de seus Dados Pessoais existentes em cadastros
              físicos e eletrônicos, fichas, registros e demais informações e documentos inerentes e
              que se encontram arquivados e sob a responsabilidade direta da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;ou de seus prestadores de serviços devidamente contratados para esta finalidade,
              bem como sobre suas respectivas fontes, sendo certo que, determinados serviços
              prestados nos sites poderão conter condições particulares específicas em relação à
              proteção de dados.
              <br />
              <br />
              São, ainda, direitos do Titular, especificamente em relação aos seus Dados Pessoais,
              de acordo com a legislação vigente:
              <br />
              <br />
               (i)  confirmação da existência de tratamento de seus Dados Pessoais;
              <br />
               (ii)  acesso a seus Dados Pessoais;
              <br />
               (iii)  correção de seus Dados Pessoais incompletos, inexatos ou desatualizados;
              <br />
               (iv)  anonimização, bloqueio ou eliminação de seus Dados Pessoais desnecessários,
              excessivos ou tratados em desconformidade com a legislação vigente;
              <br />
               (v)  portabilidade de seus Dados Pessoais a outro fornecedor de serviço ou produto,
              mediante requisição expressa, de acordo com a regulamentação da autoridade nacional,
              observados os segredos comercial e industrial;
              <br />
               (vi)  eliminação de seus Dados Pessoais tratados com seu consentimento, salvo
              exceções legais;
              <br />
               (vii)  informação das entidades públicas e privadas com as quais a&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;realizou uso compartilhado de seus Dados Pessoais;
              <br />
               (viii)  informação sobre a possibilidade de não fornecer consentimento e sobre as
              consequências da negativa; e<br />
               (ix)  revogação do consentimento para o tratamento de seus Dados Pessoais, nos termos
              da legislação em vigor.
              <br />
            </font>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>CANAL DE CONTATO COM O ENCARREGADO DE TRATAMENTO (DPO)</b>
            </font>
            <font color="#858585">
              <br />
              <br />
              Para assegurar que o Titular possa exercer esses direitos relativos aos seus Dados
              Pessoais, a&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              , em atendimento às disposições legais, conta com área de Governança de Dados
              Pessoais, acessível única e exclusivamente pelo seguinte canal direto de atendimento:
              <br />
              <br />
            </font>
            <font color="#858585">
              <b>E-mail para contato:&nbsp;</b>
            </font>
            <a href="mailto:dpo@leomadeiras.com.br">
              <font color="#195d8d">
                <b>dpo@leomadeiras.com.br</b>
              </font>
            </a>
            <font color="#858585">
              <br />
              <br />O Titular poderá formalizar uma requisição, a qualquer momento, direcionada ao
              canal acima e/ou outros eventualmente disponibilizados para essa finalidade e
              devidamente comunicados.
              <br />
              <br />
              A&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;tratará o pedido do Titular e providenciará o quanto solicitado com brevidade,
              sempre atendendo aos prazos legais e regulatórios determinados pela Autoridade
              Nacional de Proteção de Dados (“ANPD”).
            </font>
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>MEDIDAS DE PROTEÇÃO DOS DADOS PESSOAIS</b>
            </font>
            <font color="#858585">&nbsp;A&nbsp;</font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;informa que adota todas as medidas de segurança usualmente praticadas pelo
              mercado e adequadas, visando a proteção dos Dados Pessoais contra acesso, alteração,
              divulgação ou destruição não autorizada.
              <br />
              <br />
              Essas medidas incluem análises internas de nossas práticas de coleta, armazenamento e
              processamento de dados e medidas de segurança, incluindo criptografia e medidas de
              segurança físicas apropriadas para proteger contra o acesso não autorizado a sistemas
              em que armazenamos os dados pessoais.
              <br />
              <br />O Titular é o único e exclusivo responsável por toda e qualquer senha que lhe
              seja exigida pelos sistemas eletrônicos disponibilizados pela&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              , sendo sua senha de caráter pessoal e intransferível, devendo zelar pelo seu uso e
              adotar todas as medidas de segurança razoáveis quando for acessar os sistemas
              eletrônicos disponibilizados pela&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              .<br />
              <br />
              Não obstante, o Titular deve estar ciente de que as medidas de segurança relativas à
              rede mundial de computadores, a internet, não são integralmente seguras, estando
              sujeitas a ações de terceiros mal-intencionados e, desta forma, o Titular quando do
              acesso às plataformas digitais da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              , deve se certificar de ter instalado em seus equipamentos de acesso todas as medidas
              de segurança, tais como, mas não se limitando, a firewall e antivírus.
              <br />
              <br />
              A&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;não solicita senhas dos Titulares e tampouco alterações e/ou atualização de
              cadastros, salvo por meio de seus canais próprios e oficiais de comunicação, não
              estando quaisquer terceiros autorizados para tal fim.
              <br />
              <br />
              A&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;se compromete em comunicar prontamente ao Titular e à ANPD (Autoridade Nacional
              de Proteção de Dados) a ocorrência de quaisquer incidentes de segurança que possam lhe
              acarretar quaisquer riscos ou danos relevantes, colaborando com eventuais
              investigações e atuando de forma eficaz para reparar eventuais prejuízos.
              <br />
            </font>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>COMPARTILHAMENTO DE DADOS PESSOAIS</b>
            </font>
            <font color="#858585">
              <br />
              <br />
              A&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;poderá compartilhar os Dados Pessoais com outras sociedades do mesmo grupo,
              controladoras ou controladas desta, direta ou indiretamente, por suas subsidiárias e
              coligadas, sempre com respeito às mesmas finalidades que foram indicadas na presente
              Política e na legislação vigente.
              <br />
              <br />
              Adicionalmente, a&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;compartilhará dados com empresas parceiras e fornecedores devidamente
              contratadas e autorizadas para esta finalidade (‘Operadores’), no desenvolvimento e
              prestação de serviços e venda de produtos disponibilizados ao Titular, considerando
              salvaguardas contratuais para garantia da segurança dos Dados Pessoais e dos direitos
              do Titular, permitindo-se apenas o processamento dos Dados Pessoais para fins
              específicos e de acordo com instruções do Controlador.
              <br />
              <br />
              A&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;compartilhará as informações e os respectivos documentos e Dados Pessoais nas
              hipóteses previstas em lei e/ou mediante prévio consentimento do Titular, ocasião em
              que a&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;solicitará expressa autorização para o compartilhamento de todas as informações
              e documentos.
              <br />
              <br />
              Em certas circunstâncias, a&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;poderá divulgar Dados Pessoais, na medida necessária ou apropriada, para órgãos
              governamentais, consultores e outros terceiros com o objetivo de cumprir com a
              legislação aplicável ou com uma ordem ou intimação judicial ou, ainda, se a&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;acreditar de boa-fé que tal ação seja necessária para:
              <br />
              <br />
               I.   Cumprir com uma legislação que exija tal divulgação;
              <br />
               II.   Investigar, impedir ou tomar medidas relacionadas a atividades ilegais
              suspeitas ou reais ou para cooperar com órgãos públicos ou para proteger a segurança
              nacional;
              <br />
               III.   Execução de seus contratos;
              <br />
               VI.   Investigar e se defender contra quaisquer reivindicações ou alegações de
              terceiros;
              <br />
               V.   Proteger a segurança ou a integridade dos serviços (por exemplo, o
              compartilhamento com empresas que estão sofrendo ameaças semelhantes);
              <br />
               VI.   Exercer ou proteger os direitos, a propriedade e a segurança da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;e suas empresas coligadas;
              <br />
               VII.   Proteger os direitos e a segurança pessoal de seus funcionários, usuários ou
              do público;
              <br />
               VIII.   Em caso de venda, compra, fusão, reorganização, liquidação ou dissolução
              da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              .<br />
              <br />
              A&nbsp;
            </font>
            <font color="#858585">
              <u>
                <b>REDE LEO</b>
              </u>
            </font>
            <font color="#858585">
              &nbsp;cientificará os respectivos Usuários sobre eventuais demandas legais que
              resultem na divulgação de informações pessoais, a menos que tal cientificação seja
              vedada por lei ou proibida por mandado judicial ou, ainda, se a requisição for
              emergencial. A&nbsp;
            </font>
            <font color="#858585">
              <u>
                <b>REDE LEO</b>
              </u>
            </font>
            <font color="#858585">
              &nbsp;poderá contestar essas demandas se julgar que as solicitações são excessivas,
              vagas ou feitas por autoridades incompetentes.
              <br />
            </font>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>COOKIES</b>
            </font>
            <font color="#858585">
              <br />
              <br />
              Aceitando a presente Política de Privacidade o Titular concordará com o tratamento de
              cookies, de acordo com as definições e termos dispostos abaixo:
              <br />
              <br />
            </font>
            <font color="#858585">
              <b>Definição:</b>
            </font>
            <font color="#858585">
              &nbsp;São arquivos de dados gravados no dispositivo de um visitante de um site ou
              portal (via smartphone ou computador) que registram informações de preferências do
              usuário, localização, páginas visitadas, entre outras, e que oferecem mais praticidade
              na navegação.
              <br />
            </font>
            <font color="#858585">
              <b>
                Classificação:
                <br />
                <br />
                   (i)  Quanto à validade:
                <br />
                <br />
                Cookie de sessão:
              </b>
            </font>
            <font color="#858585">
              &nbsp;são temporários e permanecem até que a página web ou o navegador sejam fechados.
              Podem ser utilizados em e-commerce para analisar padrões de tráfego na internet e para
              proporcionar melhor experiência e conteúdo contextualizado aos usuários.
              <br />
              <br />
            </font>
            <font color="#858585">
              <b>Cookie permanente:</b>
            </font>
            <font color="#858585">
              &nbsp;persistem mesmo que o navegador tenha sido fechado. Podem ser utilizados para
              lembrar de login e senha dos usuários, por exemplo, ou para garantir uma melhor
              experiência ao usuário entre diferentes sessões.
            </font>
            <font color="#858585">
              <b>
                <br />
                <br />
                   (ii)  Quanto à finalidade:
                <br />
                <br />
                Estritamente necessários:
              </b>
            </font>
            <font color="#858585">
              &nbsp;essenciais para permitir ao usuário utilizar os sites, aplicativos e serviços
              oferecidos, os quais não poderiam ser corretamente oferecidos sem esses Cookies. São
              geralmente de sessão.
              <br />
              <br />
            </font>
            <font color="#858585">
              <b>De performance:</b>
            </font>
            <font color="#858585">
              &nbsp;coletam informações anônimas sobre como os usuários utilizam e interagem com os
              sites, aplicativos e serviços oferecidos, permitindo reconhecer seus perfis e
              contabilizar as visitas e interações.
              <br />
              <br />
            </font>
            <font color="#858585">
              <b>De funcionalidade:</b>
            </font>
            <font color="#858585">
              &nbsp;permitem lembrar escolhas feitas pelos usuários (tais como login e localização)
              e proporcionam experiências mais pessoais, além de possibilitar eventuais
              customizações (quando elas estiverem disponíveis). Essas informações podem ser
              anonimizadas (transformando-se em Dados Anonimizados) e não rastreiam atividades fora
              dos sites, aplicativos e serviços oferecidos. São geralmente permanentes.
              <br />
              <br />
            </font>
            <font color="#858585">
              <b>Analíticos e de publicidade:</b>
            </font>
            <font color="#858585">
              &nbsp;permitem aos anunciantes e parceiros entregar anúncios e informações mais
              relevantes aos usuários. Também são utilizados para limitar o número de vezes que o
              usuário visualiza determinados anúncios e medir a efetividade de campanhas
              publicitárias. Eles lembram determinadas preferências dos usuários e são utilizados
              para auxiliar a traçar seus perfis visando melhorar a experiência do usuário. São
              geralmente permanentes.
              <br />
            </font>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>Como cookies poderão ser utilizados pela REDE LEO:</b>
            </font>
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <br />
          </p>

          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">A&nbsp;</font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;poderá utilizar ou não os cookies quando um usuário tiver acesso aos portais de
              internet de sua propriedade e de empresas de seu grupo empresarial. Os cookies
              associam-se unicamente com o navegador de um determinado computador, não
              proporcionando referências que permitam deduzir o nome e sobrenomes do usuário.
              <br />
              <br />
              Em razão dos cookies, é possível que a&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;reconheça os usuários que tenham se registrado em uma utilização anterior das
              páginas, o que permite que não tenham que se registrar a cada nova visita.
              <br />
              Os cookies que poderão ser utilizados nos sites e páginas web dos portais de internet
              da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">, podem ser instalados pela&nbsp;</font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              , os quais são originados dos distintos servidores operados por esta, ou a partir dos
              servidores de terceiros que prestam serviços e instalam cookies pela&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              .<br />
              <br />
              Para utilizar os portais de internet da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;não é necessário que o usuário permita a recepção de cookies enviados pela&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              , sem prejuízo de que, em tal caso, será necessário que o usuário se registre a cada
              vez que acessar um serviço que requeira registro prévio.
              <br />
              <br />
              Sempre que a opção que impeça a instalação dos cookies não tenha sido ativada, o
              usuário poderá pesquisar o disco rígido de seu computador conforme as instruções do
              próprio navegador. As informações pertinentes a esta configuração estão disponíveis em
              instruções e manuais do próprio navegador, conforme exemplos abaixo:
              <br />
              <br />
            </font>
            <font color="#858585">
              <b>Internet Explorer:</b>
            </font>
            <font color="#858585">&nbsp;</font>
            <a href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies">
              <font color="#195d8d">
                https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies
              </font>
            </a>
            <font color="#858585">
              <br />
            </font>
            <font color="#858585">
              <b>Mozilla Firefox:</b>
            </font>
            <font color="#858585">&nbsp;</font>
            <a href="https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam">
              <font color="#195d8d">
                https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam
              </font>
            </a>
            <font color="#858585">
              <br />
            </font>
            <font color="#858585">
              <b>Chrome:</b>
            </font>
            <font color="#858585">&nbsp;</font>
            <a href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR">
              <font color="#195d8d">
                https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&amp;hl=pt-BR
              </font>
            </a>
            <font color="#858585">
              <br />
            </font>
            <font color="#858585">
              <b>Safari:</b>
            </font>
            <font color="#858585">&nbsp;</font>
            <a href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac">
              <font color="#195d8d">
                https://support.apple.com/pt-br/guide/safari/sfri11471/mac&gt;
              </font>
            </a>
            <font color="#858585">
              <br />
              <br />
              Importante salientar que não haverá garantia do correto funcionamento dos portais de
              internet de propriedade da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;e de empresas de seu grupo empresarial, caso cookies estritamente necessários
              sejam negados.
              <br />
            </font>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>CONSIDERAÇÕES ADICIONAIS</b>
            </font>
            <font color="#858585">
              <br />
              <br />O Titular garante que os Dados Pessoais fornecidos à&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;são verdadeiros e legítimos, ausente de quaisquer vícios de consentimento, bem
              como, se compromete desde já, em comunicar imediatamente à&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;sobre qualquer modificação no mesmo.
              <br />
              <br />
              Salvo nos campos em que se indique o contrário, as respostas às perguntas sobre Dados
              Pessoais são facultativas, sendo que sua ausência não implica em redução da qualidade
              ou quantidade dos serviços correspondentes.
              <br />
              <br />
              A&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;poderá deliberar sobre o processamento de solicitações que sejam exageradamente
              repetitivas ou sistemáticas, que exijam um esforço técnico desproporcional, que
              prejudiquem a privacidade de outros, que sejam impraticáveis ou para as quais o acesso
              não seja exigido de outra forma.
              <br />
              <br />
              A&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;proporcionará aos Titulares, os recursos adequados para que possam, com caráter
              prévio, aquiescer com esta Política ou com qualquer outra informação relevante antes
              de prestarem seu consentimento sobre o armazenamento dos respectivos Dados Pessoais.
              <br />
            </font>
            <br />
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <font color="#858585">
              <b>ALTERAÇÕES DESTA POLÍTICA</b>
            </font>
            <font color="#858585">
              <br />
              <br />
              Esta Política de Privacidade poderá, a critério da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              &nbsp;ser atualizada e/ou alterada a qualquer momento, sem prejuízo dos direitos dos
              Titulares garantidos pela legislação em vigor, atualização esta que será explicitada
              pela&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              , com destaque, por meio de seus canais de comunicação, incluindo o respectivo
              destaque na própria Política. Eventuais atualizações e/ou alterações que afetem
              direitos dos Titulares e/ou obrigações da&nbsp;
            </font>
            <font color="#858585">
              <b>REDE LEO</b>
            </font>
            <font color="#858585">
              , bem como decorrentes da legislação em vigor, poderão ser objeto de comunicação
              específica.
            </font>
          </p>
          <p
            style={{
              marginBottom: "0in",
              background: "rgb(255, 255, 255)",
              lineHeight: "100%",
            }}>
            <br />
            <br />
          </p>
        </div>
      </div>
    </>
  );
}
